// src/serviceWorkerRegistration.js
// Registers the SoldiKeeper service worker for offline mode

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/sw.js`;
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('✅ SW registered:', registration.scope);
          registration.onupdatefound = () => {
            const worker = registration.installing;
            if (worker) {
              worker.onstatechange = () => {
                if (worker.state === 'installed' && navigator.serviceWorker.controller) {
                  console.log('🔄 New SW version available');
                  worker.postMessage('skipWaiting');
                }
              };
            }
          };
        })
        .catch((err) => {
          console.warn('SW registration failed:', err);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch(() => {});
  }
}
